import { BankStatementType } from "interfaces";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { IStores } from "stores";
import { getBankStatement } from "services";
import { reaction, makeObservable, observable, action } from "mobx";

export class BankStatementStore extends ListStoreConstructor<BankStatementType> {
  id = "";

  setId(id: string) {
    this.id = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      async (): Promise<{ content: BankStatementType[]; size: number; totalPages: number; totalElements: number }> => {
        const res = await getBankStatement({ id: this.id });
        const accountDetailsList = res.accountDetailsList as BankStatementType[];

        return {
          content: accountDetailsList,
          size: accountDetailsList?.length || 0,
          totalPages: 1,
          totalElements: accountDetailsList?.length || 0,
        };
      },
      {
        pollingInterval: 0,
      }
    );
  }
}
